import { api } from '../../lib/api-client';

export type TalentVideoItem = {
  /** `CandidateVideo.PublicKey` Guid. */
  id: string;
  title: string;
  mimeType: string;
  durationSeconds: number | null;
};

export type TalentVideosResponse = {
  items: TalentVideoItem[];
};

export type PlaybackUrlResponse = {
  url: string;
  expiresAt: string; // ISO datetime
  mimeType: string;
};

export type ListVideosParams = {
  shortlistPublicKey: string;
  talentPublicKey: string;
};

export type PlaybackUrlParams = ListVideosParams & {
  videoPublicKey: string;
};

export async function listTalentVideos(params: ListVideosParams): Promise<TalentVideosResponse> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}/videos`;
  return api.get<TalentVideosResponse>(url);
}

export async function getPlaybackUrl(params: PlaybackUrlParams): Promise<PlaybackUrlResponse> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}` +
    `/videos/${params.videoPublicKey}/playback-url`;
  return api.get<PlaybackUrlResponse>(url);
}
